import { render, staticRenderFns } from "./TabBarNav.vue?vue&type=template&id=5a8cae3d&scoped=true"
import script from "./TabBarNav.vue?vue&type=script&lang=js"
export * from "./TabBarNav.vue?vue&type=script&lang=js"
import style0 from "./TabBarNav.vue?vue&type=style&index=0&id=5a8cae3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8cae3d",
  null
  
)

export default component.exports